function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useEffect, useState } from 'react';
import { compact } from 'lodash-es';
import { DropdownMenu, TableList, TableListActions, Typography } from 'seagull';
import { CopyFill, TrashLine } from 'seagull/icons';
import { serviceTemplateModel } from "../../../models";
import { Accounting } from "../../../types/api.model";
import { billingTriggerLabel, ColumnId, occurrenceLabel } from "./CommonServicesPage.utils";
import styles from "./RowItem.module.scss";
import { ServiceRowName } from "./ServiceRowName";
import { ServiceRowPrice } from "./ServiceRowPrice/ServiceRowPrice";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RowItem(_ref) {
  let {
    service: initialService,
    qboItemsById,
    xeroItemsById,
    serviceNameValidation,
    onInlineEdit: onInlineEditProp,
    onEdit,
    onDuplicate,
    onDelete,
    onInputFocus,
    onInputBlur,
    columns,
    isHeightFluid
  } = _ref;
  const [service, setService] = useState(initialService);
  const qboIntegratedId = serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting: Accounting.QBO
  });
  const xeroIntegratedId = serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting: Accounting.Xero
  });
  useEffect(() => {
    setService(initialService);
  }, [initialService]);
  const onInlineEdit = useCallback(edit => {
    const newService = _objectSpread(_objectSpread({}, service), edit);
    onInlineEditProp(newService);
    setService(newService);
  }, [service, onInlineEditProp]);
  function nameColumn() {
    var _qboItemsById$qboInte, _xeroItemsById$xeroIn;
    return /*#__PURE__*/_jsx(ServiceRowName, {
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur,
      service: service,
      serviceNameValidation: serviceNameValidation,
      onInlineEdit: onInlineEdit,
      qboServiceDisplay: qboIntegratedId && ((_qboItemsById$qboInte = qboItemsById[qboIntegratedId]) === null || _qboItemsById$qboInte === void 0 ? void 0 : _qboItemsById$qboInte.name),
      xeroServiceDisplay: xeroIntegratedId && ((_xeroItemsById$xeroIn = xeroItemsById[xeroIntegratedId]) === null || _xeroItemsById$xeroIn === void 0 ? void 0 : _xeroItemsById$xeroIn.name)
    });
  }
  function occurenceColumn() {
    return /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      children: occurrenceLabel(service.billing)
    });
  }
  function billingColumn() {
    return /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      skin: "secondary",
      children: billingTriggerLabel(service.billing)
    });
  }
  function includedServicesColumn() {
    var _service$bundle;
    return /*#__PURE__*/_jsx(Typography, {
      skin: "secondary",
      testId: "service-library-row-included-services",
      children: /*#__PURE__*/_jsx("ul", {
        className: styles.includedServices,
        children: (_service$bundle = service.bundle) === null || _service$bundle === void 0 ? void 0 : _service$bundle.services.map((_ref2, index) => {
          let {
            name
          } = _ref2;
          return /*#__PURE__*/_jsx("li", {
            children: name
          }, "".concat(service.id, "-").concat(index));
        })
      })
    });
  }
  function rateColumn() {
    return /*#__PURE__*/_jsx(ServiceRowPrice, {
      service: service,
      onInlineEdit: onInlineEdit,
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur
    });
  }
  function getColumnItems() {
    const columnsMap = {
      [ColumnId.Name]: nameColumn,
      [ColumnId.Rate]: rateColumn,
      [ColumnId.BillingOccurance]: occurenceColumn,
      [ColumnId.BillingTrigger]: billingColumn,
      [ColumnId.IncludedServices]: includedServicesColumn
    };
    return compact(columns.map(column => ({
      value: columnsMap[column]()
    })));
  }
  return /*#__PURE__*/_jsx(TableList.Row, {
    testId: "service-library-row",
    rowId: service.id,
    size: isHeightFluid ? 'fluid' : 'medium',
    actionColumn: /*#__PURE__*/_jsxs(TableListActions, {
      buttonText: "Edit",
      testId: "service-library-row-actions",
      onClickButton: onEdit,
      children: [/*#__PURE__*/_jsx(DropdownMenu.Item, {
        iconStart: /*#__PURE__*/_jsx(CopyFill, {}),
        testId: "service-library-row-duplicate",
        onClick: onDuplicate,
        children: "Duplicate"
      }), /*#__PURE__*/_jsx(DropdownMenu.Item, {
        skin: "error",
        iconStart: /*#__PURE__*/_jsx(TrashLine, {}),
        testId: "service-library-row-delete",
        onClick: onDelete,
        children: "Delete"
      })]
    }),
    items: getColumnItems()
  });
}